module.exports = __webpack_public_path__ + "img/Kein.f1f4125e.svg";